export default __webpack_public_path__ + "static/media/login_rouding_background_2_1.ee8b3c17.png";